/* istanbul ignore file */
import { mainApi } from "config";
import { IProgressState, getProgress } from "infrastructure/helpers";
import { getClientFor } from "infrastructure/http";
import { IApiError } from "ui/shared/models/common";

export interface ITermTranslationsUploadResponseItem {
  uniqueId: string;
  key: string;
  translationId: string;
  locale: string;
  industry: string;
  termTranslation: string;
  definitionTranslation: string;
  error: IApiError;
}

const apiProvider = () => {
  return {
    uploadTranslations: async (file: File, onProgress: (currentProgress: IProgressState) => void): Promise<ITermTranslationsUploadResponseItem[]> => {
      const config = {
        onUploadProgress: function(progressEvent) {
          onProgress(getProgress(progressEvent.loaded, progressEvent.total));
        }
      };

      const formData = new FormData();
      formData.append("file", file);

      return (await getClientFor(mainApi.name).post<ITermTranslationsUploadResponseItem[]>("/term-translations/upload", formData, config)).data;
    }
  };
};

export const termTranslationsUploadApi = apiProvider();
